import React from 'react'
/**
 * These are not cacheable and therefore not optimized.
 * But they work in cms server side rendering
 **/

const EthosLogoFancyO = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 83 16"
    {...props}
  >
    <title>ethos-logo-O</title>
    <path d="M55.203 11.2063C53.028 9.03135 51.6959 5.03092 54.1506 0.801941L53.0033 1.94928C49.8399 5.11267 49.8399 10.242 53.0033 13.4054C56.1673 16.5694 61.296 16.5694 64.46 13.4054L65.6073 12.2581C61.5798 14.5994 57.5719 13.5752 55.203 11.2063Z" fill="#056257"/>
    <path d="M64.5872 1.82205C62.4261 -0.339649 58.9213 -0.339649 56.7591 1.82205C56.4465 2.13464 55.7959 2.86634 55.5737 3.22672C57.7072 1.91128 60.5379 2.17264 62.387 4.02231C64.2286 5.86393 64.4957 8.6773 63.1993 10.8079L63.5245 10.5609C63.8826 10.3007 64.3299 9.90869 64.5878 9.65078C66.7495 7.48909 66.7495 3.98489 64.5878 1.82262L64.5872 1.82205Z" fill="#056257"/>
  </svg>
)

export default EthosLogoFancyO
